import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const ProtectedRoute: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    // Muestra un loader mientras se verifica el estado de autenticación
    return <div>Cargando...</div>; 
  }

  // Si no está autenticado, redirige a la página de login
  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;